import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import iconChevronLeftPrimaryUrl from '../../assets/icon/chevron-left-primary.svg';
import loginBannerUrl from '../../assets/images/LoginBanner.svg';
import { resetStateAction } from '../../store/login/actions';
import { getCustomerCode, getPhoneNumber } from '../../store/login/selectors';
import LanguagePicker from "../../components/LanguagePicker";
import loginBannerUrlPhone from '../../assets/images/LoginBannerPhone.svg';
import './index.scss';

export interface LoginLayoutProps {
  root?: boolean;
}

const LoginScreen = (props: LoginLayoutProps) => {
  const { root = false } = props;
  const dispatch = useDispatch();
  const phone = useSelector(getPhoneNumber);
	const customerCode = useSelector(getCustomerCode);

  const handleBack = () => {
    dispatch(resetStateAction({phone, customerCode, canForgotPassword: false}));
    window.history.back();
  };

  return (
    <div className="login-container">
      <img className="banner-img" src={loginBannerUrl} alt="logo" />
      <img className="banner-img-phone" src={loginBannerUrlPhone} alt="logo-phone" />
      <div className="login-form-container">
        <LanguagePicker className={'layout-language-picker'}/>
        <div className="login-form">
          {!root && (
            <div className='back-button-wrap'>
              <div
                className="back-button"
                onClick={() => {
                  handleBack();
                }}
              >
                <img
                  src={iconChevronLeftPrimaryUrl}
                  style={{
                    marginInline: '8px',
                    color: 'rgb(179, 68, 109)',
                    fontSize: '16px',
                  }}
                />
              </div>
            </div>
          )}
          <div className="login-field">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
